/**
 * TEST previews and tunnels must not be indexed. Keep titles, canonicals,
 * and sitemap markup ready so sweetlisteners.com can be indexed at go-live.
 */
export const hostFromOrigin = value => {
  if (!value || typeof value !== 'string') {
    return '';
  }
  try {
    if (/^https?:\/\//i.test(value)) {
      return new URL(value).host;
    }
  } catch (e) {
    // Fall through to the raw host parse below.
  }
  return value.replace(/^https?:\/\//i, '').split('/')[0];
};

export const isNonIndexableHost = hostOrOrigin => {
  const host = hostFromOrigin(hostOrOrigin).toLowerCase();
  if (!host) {
    return true;
  }
  return (
    host === 'localhost' ||
    host.startsWith('localhost:') ||
    host.startsWith('127.0.0.1') ||
    host.endsWith('.fly.dev') ||
    host.endsWith('.trycloudflare.com') ||
    host.endsWith('.mysharetribe-test.com') ||
    host.endsWith('.local')
  );
};
